'use client'

import { Link, useFetcher } from 'react-router'
import { Button } from '#app/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from '#app/components/ui/dropdown-menu'
import { Icon } from '#app/components/ui/icon'
import { isLogoutNavigationItem } from '#app/utils/pz/navigation/menuActions'
import { type NavigationItem } from '#app/utils/pz/navigation/resolveNavigation'

interface NavUserMenuProps {
	items: NavigationItem[]
	user: any
}

export function NavUserMenu({ items, user }: NavUserMenuProps) {
	const logoutFetcher = useFetcher()

	const handleLogout = () => {
		void logoutFetcher.submit(new FormData(), {
			method: 'post',
			action: '/logout',
		})
	}
	const userName = user?.username || 'User'

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					variant="ghost"
					size="icon"
					className="bg-primary hover:bg-primary/90 rounded-full"
				>
					<span className="text-primary-foreground font-semibold">
						{userName.charAt(0).toUpperCase()}
					</span>
					<span className="sr-only">User menu</span>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="w-56">
				{items.map((item) => {
					if (isLogoutNavigationItem(item)) {
						return (
							<DropdownMenuItem
								key={item.id}
								onClick={handleLogout}
								className="cursor-pointer"
							>
								<Icon name={item.icon} className="mr-2 h-4 w-4" />
								<span>{item.name}</span>
							</DropdownMenuItem>
						)
					}

					// Regular link items
					return (
						<DropdownMenuItem key={item.id} asChild>
							<Link to={item.href} className="flex items-center">
								<Icon name={item.icon} className="mr-2 h-4 w-4" />
								<span>{item.name}</span>
							</Link>
						</DropdownMenuItem>
					)
				})}
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
